import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { AuditLog } from '@reflact/ipkv-types';
import { firstValueFrom } from 'rxjs';

export type AuditFilters = {
  statusId?: string
}
@Injectable({
  providedIn: 'root'
})
export class AuditlogService {

  private baseRoute = "/api/admin/audit";
  private http = inject(HttpClient);

  public auditLogs: AuditLog<string, Date>[] = [];

  public async list(filters?: AuditFilters) {
    const opts = filters == null ? {} : filters;
    const res = await firstValueFrom(this.http.post<AuditLog[]>(this.baseRoute + "/list", opts));
    this.auditLogs = res.map(r => {
      return { ...r, created: new Date(r.created) };
    });
  }




}
